"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Loading = () => ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: "oidc-loading" }, { children: "Loading" })));
exports.default = Loading;
//# sourceMappingURL=Loading.component.js.map